// extracted by mini-css-extract-plugin
module.exports = {"dropdown_wrapper":"DropdownShoppingBag_dropdown_wrapper__IvAte","product_wrapper":"DropdownShoppingBag_product_wrapper__9C6am"};